<template>
  <vDialog :show.sync="visible">
    <template #body>
      <i class="el-icon-close closeButton" @click="visible = false" />
      <el-row class="dialog-info">
        <i class="el-icon-warning-outline warning_icon_blue"></i>
        <div class="dialog-content">
          <div class="title">{{ $t('sessionDialog.title') }}</div>
          <div class="content">{{ $t('sessionDialog.content') }}</div>
        </div>
      </el-row>
    </template>
    <template #btn>
      <el-row class="btn_box">
        <el-button class="blue_button" @click="keepIn" data-testid="keepIn">{{ $t('sessionDialog.keepIn') }}</el-button>
        <el-button class="white_button" @click="signOut" data-testid="signOut">{{
          $t('sessionDialog.signOut')
        }}</el-button>
      </el-row>
    </template>
  </vDialog>
</template>

<script>
import vDialog from '@/components/vDialog.vue';
import { setCookies, getCookies, getExpiresTime } from '@/util/cookies';
import { minusTime } from '@/util/time';
import helper from '@/util/signinHelper';

export default {
  components: { vDialog },
  data() {
    return {
      visible: false,
      alertSec: 60 * 1000,
      countDown: null,
      totalTime: null,
      signOutTimer: null,
      previousExpiresTime: null
    };
  },
  mounted() {
    this.inital();
  },
  methods: {
    inital() {
      this.previousExpiresTime = getExpiresTime('token');
      this.setTime(this.getTotalTime() - this.alertSec, this.timeoutFunc);
    },
    timeoutFunc() {
      // 獲取新的過期時間
      const newExpiresTime = getExpiresTime('token');
      // 如果新的過期時間大於之前的過期時間, 表示用戶已經重新登入或刷新了 token
      if (newExpiresTime > this.previousExpiresTime) {
        // 更新之前的過期時間
        this.previousExpiresTime = newExpiresTime;
        // 重新設置超時計時器
        this.setTime(this.getTotalTime() - this.alertSec, this.timeoutFunc);
        return;
      }

      this.countDown = 60;
      this.signOutTimer = this.setInter(1000, this.intervalFunc);
      this.visible = true;
    },
    intervalFunc() {
      const newExpiresTime = getExpiresTime('token');
      // 如果新的過期時間大於之前的過期時間, 表示用戶已經重新登入或刷新了 token
      if (newExpiresTime > this.previousExpiresTime) {
        // 更新之前的過期時間
        this.previousExpiresTime = newExpiresTime;
        // 重新設置超時計時器
        this.setTime(this.getTotalTime() - this.alertSec, this.timeoutFunc);
        this.visible = false;
        clearInterval(this.signOutTimer);
        return;
      }

      this.countDown >= 0 ? this.countDown-- : this.signOut();
    },
    setTime(time, func) {
      return setTimeout(() => {
        func();
      }, time);
    },
    setInter(time, func) {
      return setInterval(() => {
        func();
      }, time);
    },
    getTotalTime() {
      return minusTime(new Date(), this.previousExpiresTime);
    },
    keepIn() {
      if (!getCookies('token')) return this.signOut();

      const token = getCookies('token');
      setCookies('token', token, 30);
      this.setTime(this.getTotalTime() - this.alertSec, this.timeoutFunc);
      clearInterval(this.signOutTimer);
      this.visible = false;
    },
    signOut() {
      this.visible = false;
      clearInterval(this.signOutTimer);
      helper.signOut(null, 'idleSessionDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/sessionDialog.scss';
</style>
